import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { Clickable } from '@components/ringil3/styles';
import COHeadline from '@components/framework/headlines/COHeadline.tsx';

interface ComponentProps {
  onClose?: () => void;
  headingText: string;
  closeIcon?: JSX.Element;
  /** Leading icon on the heading, forwarded to COHeadline (which tints it for us). */
  icon?: JSX.Element;
}

const Panel: React.FC<PropsWithChildren<ComponentProps>> = ({ children, onClose, closeIcon, headingText, icon }) => {
  return (
    <PanelInner>
      {headingText && (
        <PanelHeader>
          <COHeadline variant={'h4'} title={headingText} icon={icon}></COHeadline>
          <Clickable onClick={e => (onClose ? onClose() : {})}>{closeIcon}</Clickable>
        </PanelHeader>
      )}

      <PanelContent>{children}</PanelContent>
    </PanelInner>
  );
};

const PanelHeader = styled.div`
  display: flex;
  justify-content: space-between;
`;

const PanelInner = styled.div`
  display: flex;
  flex-direction: column;
  background-color: var(--base-basesecondary);
  padding: 1.5rem 1rem;
  border-radius: 0.5rem;
`;

const PanelContent = styled.div`
  display: flex;
`;

export default Panel;
